<script>
import { mapState, mapMutations } from 'vuex';
import { get } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faChevronDown, faFilm } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';

import config from '@/config/config';
import Menu from './Menu';

library.add(faCheckCircle, faChevronDown, faFileAlt, faFilm);

export default {
  name: 'Course_B_Part',
  components: {
    Menu,
  },
  data() {
    return {
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
        controls: 1,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
        cc_load_policy: 0,
        cc_lang_pref: 'en',
        wmode: 'transparent',
        modestbranding: 1,
        disablekb: 1,
        origin: 'https://wszystkozaczynasiewglowie.pl',
        enablejsapi: 1,
        widgetid: 1,
      }
    }
  },
  computed: {
    ...mapState(config.app, [
      'course',
      'currentLectureIndex',
    ]),
    lectures() {
      return get(this, 'course.lectures', []);
    },
    lecture() {
      return !this.lectures[this.currentLectureIndex] ? {} : this.lectures[this.currentLectureIndex];
    },
    video() {
      return get(this, 'lecture.video', {});
    },
    videoFile() {
      return get(this, 'lecture.video.video.url');
    },
    material() {
      return get(this, 'lecture.material', {});
    },
  },
  methods: {
    ...mapMutations(config.app, [
      'setCurrentCourse',
      'setCurrentLectureIndex',
    ]),
    next() {
      if (this.lectures[this.currentLectureIndex] && this.lectures[this.currentLectureIndex].material) {
        this.setCurrentCourse(this.flow.materials);
        return;
      }

      const nextIndex = this.currentLectureIndex + 1;

      if (this.lectures[nextIndex] && this.lectures[nextIndex].video) {
        this.setCurrentCourse(this.flow.video);
        this.setCurrentLectureIndex(nextIndex);
        return;
      }

      if (this.lectures[nextIndex] && this.lectures[nextIndex].material) {
        this.setCurrentCourse(this.flow.materials);
        this.setCurrentLectureIndex(nextIndex);
        return;
      }

      if (this.isLast) {
        this.setCurrentCourse(this.flow.finish);
        return;
      }

      this.setCurrentCourse(this.flow.lecture);
      this.setCurrentLectureIndex(0);
    },
    getVideoId() {
      const { video } = this;
      if (!video.videoUrl) {
        return null;
      }
      return this.$youtube.getIdFromUrl(video.videoUrl);
    },
  },
}
</script>
<style lang="scss" scoped>
    .course-part {
        box-shadow: 1.5px 2.6px 10px 0 rgba(119, 119, 119, .75);

        ul {
            li {
                padding-bottom: 1em;
                & > svg {
                    color: #e4a05f;
                }
            }
        }

        .btn {
            color: white !important;
        }

        video {
            max-width: 100%;
        }
    }
    .actions {
        flex: 1;
        text-align: right;
    }
</style>
<template>
    <div>
        <Menu :total="lectures.length" :currentIndex="currentLectureIndex" :setIndex="setCurrentLectureIndex" />
        <div class="course-part bg-white rounded p-3 d-flex flex-column">
            <div class="wrapper">
                <youtube v-if="getVideoId()" :video-id="getVideoId()" :player-vars="playerVars" ref="youtube" :fitParent="true" :resize="true" />
                <video v-else controls :key="videoFile" controlsList="nodownload" oncontextmenu="return false;">
                    <source :src="videoFile" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>

            <div v-html="video.content" class="mt-5 mb-5" />

            <div v-html="material.content" class="mt-5 mb-5" />

            <ul>
                <li v-for="(file, index) in material.files" :key="index" class="d-flex">
                    <span class="font-weight-bold small">{{ index + 1 > 9 ? index + 1 : `0${index + 1}`}}</span>
                    <font-awesome-icon :icon="['far', 'file-alt']" size="3x" class="mr-3 ml-2" />
                    <h3>{{ file.name }}</h3>
                    <div class="actions">
                        <a :href="file.url" target="_blank" class="btn btn-link">
                            ZOBACZ
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
